import React, {useEffect, useState} from "react";

import "../../styles/signup-mobile.css";
import ManagedEconomyForm from "./ManagedEconomyForm";
import PricingPageAfterSignup from "./pricingPageAfterSignup";
import NavBarComponent from "../navBar/NavBarComponent";
import {Transition} from "@headlessui/react";
import { motion } from "framer-motion";

export default function BookCallComponent() {
  const [page, setPage] = useState("main")  // main or pricing
  const [formStep, setFormStep] = useState(0)
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 1024)

  const [shouldDisplay, setShouldDisplay] = useState(false)  // For the form

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [])

  useEffect(() => {
    setShouldDisplay(true)
    const urlParams = new URLSearchParams(window.location.search);
    const page = urlParams.get('page');

    if (page === "create") {
      setPage("pricing")
    }
  })

  return (
      <div>
        {
          page === "main" && mainView()
        }
        {
          page === "pricing" && pricingView()
        }
      </div>
  )

  function mainView() {
    return (
        <div>
          <NavBarComponent />

          <div className="main-wrapper">
            <div
                className="div-block-737"
                style={{
                  background: "#faf2eb",
                }}
            >
              <div className="div-block-738">
                <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", alignItems: "flex-start", gap: isMobile ? "32px" : "40px" }}>
                  <motion.div
                    animate={{ flex: isMobile ? "0 0 100%" : (formStep === 0 ? "0 0 58%" : "0 0 38%") }}
                    transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
                    style={{ overflow: "hidden", minWidth: 0, width: isMobile ? "100%" : undefined }}
                  >
                    <div>
                      <p className="text-xs font-bold uppercase tracking-widest mb-3" style={{ color: "#15803d" }}>
                        Managed Economy
                      </p>
                      <h1 className="heading center" style={{ textAlign: "left" }}>
                        Put an economist behind your brand.
                      </h1>
                      <div className="demo-sub-heading">
                        <p className="paragraph-152">
                          Managed Economy puts a dedicated Economist inside your brand. They design your campaigns, run them, and keep your currency healthy. You set the direction. We handle the rest.                        </p>
                      </div>
                    </div>

                    <div className="div-block-740 mt-6">
                      <div className="div-block-741">

                        {[
                          {
                            icon: (
                              <svg width={22} height={22} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 3L2 7l10 4 10-4-10-4zM2 17l10 4 10-4M2 12l10 4 10-4" stroke="#15803d" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                            ),
                            title: "Campaign design & execution",
                            body: "Your economist builds and runs every credit campaign end-to-end. You approve the direction. We do the rest."
                          },
                          {
                            icon: (
                              <svg width={22} height={22} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="#15803d" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                            ),
                            title: "Currency health & safety",
                            body: "We monitor the stability of your economy — so your currency never becomes a liability, a cost center, or a customer complaint."
                          },
                          {
                            icon: (
                              <svg width={22} height={22} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx={12} cy={12} r={10} stroke="#15803d" strokeWidth={2}/>
                                <path d="M12 6v6l4 2" stroke="#15803d" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                            ),
                            title: "Async, always on",
                            body: "No weekly calls eating your calendar. Your economist moves when you move, communicates in writing, and ships work."
                          },
                          {
                            icon: (
                              <svg width={22} height={22} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M22 12h-4l-3 9L9 3l-3 9H2" stroke="#15803d" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                            ),
                            title: "Full ownership, zero overhead",
                            body: "From issuance strategy to redemption patterns, your economy runs on a deliberate plan."
                          },
                        ].map(({ icon, title, body }, i) => (
                          <div key={i} className="w-layout-grid demo-pointer-wrapper" style={{ alignItems: "flex-start", marginBottom: "16px" }}>
                            <div style={{ marginTop: "2px", flexShrink: 0 }}>{icon}</div>
                            <div>
                              <div className="text-block-6" style={{ fontWeight: 700, marginBottom: "2px" }}>{title}</div>
                              <div style={{ fontSize: "13px", color: "#6b7280", lineHeight: "1.5" }}>{body}</div>
                            </div>
                          </div>
                        ))}

                      </div>
                    </div>
                  </motion.div>

                  <motion.div
                    animate={{ flex: isMobile ? "0 0 100%" : (formStep === 0 ? "0 0 42%" : "0 0 62%") }}
                    transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
                    style={{ minWidth: 0, width: isMobile ? "100%" : undefined }}
                  >
                    {handleTransition()}
                  </motion.div>

                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }


  function handleTransition() {
    return (
        <div>
          <Transition
              show={shouldDisplay}
              enter="transition-opacity duration-1000"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity duration-100"
              leaveFrom="opacity-50"
              leaveTo="opacity-0"
          >

            <div className="py-4">
                <ManagedEconomyForm onStepChange={setFormStep} />
              </div>
          </Transition>

        </div>
    )
  }

  function pricingView() {
    return (
        <div>
          <PricingPageAfterSignup />
        </div>
    )
  }
};

